
import { defineComponent, SetupContext } from "vue";
import { getApplianceCategoryBlackIcon } from "@/utils/resource-util";
import { Nutrition, Reaction } from "@/types/recipes";
import { RecipeComment } from "@/types/common";

export default defineComponent({
  name: "DetailTitleView",
  props: {
    subTitle: {
      type: String
    },
    title: {
      type: String
    },
    label: {
      type: String
    },
    labelColor: {
      type: String
    },
    labelBackgroundColor: {
      type: String
    },
    note: {
      type: String
    },
    applianceCategory: {
      type: String,
      required: true
    },
    applianceCategoryId: {
      type: Number,
      required: true
    },
    nutrition: {
      type: Nutrition
    },
    reactions: {
      type: Reaction
    },
    recipeComment: {
      type: RecipeComment,
      default: null,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const isShowLabel = () => {
      return props.label && props.labelColor && props.labelBackgroundColor;
    };

    const getLabelColor = () => {
      return props.labelColor;
    };

    const getLabelBackgroundColor = () => {
      return props.labelBackgroundColor;
    };

    /**
     * 機種アイコンを取得する
     */
    const getCategoryIcon = (applianceCategoryId: number) => {
      const icon = getApplianceCategoryBlackIcon(applianceCategoryId);
      return icon;
    };

    const isShowNutrition = () => {
      return (
        props.nutrition && props.nutrition.calories && props.nutrition.salt
      );
    };

    const getNutritionNote = () => {
      return props.nutrition && props.nutrition.note
        ? "(" + props.nutrition.note + ")"
        : null;
    };

    const getCalories = () => {
      return props.nutrition ? props.nutrition.calories : "";
    };

    const getSalt = () => {
      return props.nutrition ? props.nutrition.salt : "";
    };

    const getCommentCount = () => {
      return (props.recipeComment != null) ? props.recipeComment.total_number : 0;
    };

    return {
      isShowLabel,
      getLabelColor,
      getLabelBackgroundColor,
      getCategoryIcon,
      isShowNutrition,
      getNutritionNote,
      getCalories,
      getSalt,
      getCommentCount
    };
  }
});
